module.exports = __webpack_public_path__ + "img/productActive-3.dd509f0e.svg";